import React from 'react';
import VerticalMenu from '../../components/VerticalMenu';
import { 
Grid, 
  Box, 
  Container, 
  Typography,
  useTheme,
  useMediaQuery,
  CircularProgress
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useUser } from '../../hooks/useUser';

export default function Account() {
  const { currentUser, loading } = useUser();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (loading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box 
      sx={{ 
        minHeight: { xs: '100vh', md: '220px' },
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#F5F7F9',
        py: { xs: 2, sm: 4 }
      }}
    >      
      <Container 
        maxWidth="lg"
        sx={{ 
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box 
          sx={{ 
            boxShadow: { xs: 1, sm: 3 },
            bgcolor: 'background.paper',
            borderRadius: { xs: 2, sm: 3 },
            borderTop: '4px solid #51DF94',
            overflow: 'hidden',
            transition: 'all 0.3s ease',
            '&:hover': {
              boxShadow: { sm: 6 }
            }
          }}
        >
          <Grid container>
            <Grid 
              item 
              xs={12}
              sx={{ 
                bgcolor: 'background.paper',
                borderBottom: 1,
                borderColor: 'divider',
                p: { xs: 2, sm: 3 }
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2
                }}
              >
                <AccountCircleIcon 
                  sx={{ 
                    fontSize: { xs: 32, sm: 40 },
                    color: 'primary.main'
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    color: 'text.primary',
                    fontWeight: 600,
                    fontSize: {
                      xs: 20,
                      sm: 24
                    },
                    textAlign: 'left'
                  }}
                >
                  Meus dados
                </Typography>
              </Box>
            </Grid>
            
            <Grid 
              item 
              xs={12}
              sx={{
                bgcolor: 'background.paper',
                p: { xs: 2, sm: 4 },
                minHeight: { xs: 'calc(100vh - 200px)', md: 'auto' }
              }}
            >
              <Box
                sx={{
                  maxWidth: 'md',
                  mx: 'auto'
                }}
              >
                <VerticalMenu currentUser={currentUser} isMobile={isMobile} />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
